import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"margin-top":"1rem"}
}

interface Props {
  icon?: string
  title: string
  description: string
  clickable?: boolean
  actionText?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SupportCard',
  props: {
    icon: { default: '' },
    title: {},
    description: {},
    clickable: { type: Boolean, default: true },
    actionText: { default: 'details' }
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

/* eslint-disable no-undef */
const props = __props

const emit = __emit
/* eslint-enable no-undef */

const handleClick = () => {
  if (props.clickable) {
    emit('click')
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "program-card",
    onClick: handleClick,
    style: _normalizeStyle({ cursor: __props.clickable ? 'pointer' : 'default' })
  }, [
    _createElementVNode("h4", null, _toDisplayString(__props.icon) + " " + _toDisplayString(__props.title), 1),
    _createElementVNode("p", null, _toDisplayString(__props.description), 1),
    (__props.clickable)
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, [
          _createElementVNode("strong", null, "Click to view " + _toDisplayString(__props.actionText) + " →", 1)
        ]))
      : _createCommentVNode("", true)
  ], 4))
}
}

})